exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overflow-on .cell[data-v-50b9c50d]{overflow:visible;overflow-x:visible;overflow-y:visible}.el-table__row button[data-v-50b9c50d]{margin:5px}.hotel-table[data-v-50b9c50d] .el-button+.el-button{margin-left:5px}\n", ""]);

// exports
